import { render } from "./pos-warehouse.vue?vue&type=template&id=61a96952"
import script from "./pos-warehouse.vue?vue&type=script&lang=js"
export * from "./pos-warehouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__